import React from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "@client-app/i18n";
import { AdminProvider } from "./AdminContext";
import { AuthProvider } from "./AuthContext";
import { DialogProvider } from "./DialogContext";
import { OnboardingProvider } from "./OnboardingContext";
import { ToastProvider } from "./ToastContext";

export const AppProvider = () => {
    return (
        <I18nProvider>
            <ToastProvider>
                <DialogProvider>
                    <AuthProvider>
                        <OnboardingProvider>
                            <AdminProvider>
                                <Outlet />
                            </AdminProvider>
                        </OnboardingProvider>
                    </AuthProvider>
                </DialogProvider>
            </ToastProvider>
        </I18nProvider>
    )
}

export const CloudAgentProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    return (
        <ToastProvider>
            <DialogProvider>
                {children ?? <Outlet />}
            </DialogProvider>
        </ToastProvider>
    )
}
